import clevertap from "clevertap-web-sdk";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import Modal from "components/LoginAndRegister/Modal";
import { SharePopup } from "components/CollectionDetails/SharePopup";
import { UnlockDiscount } from "../UnlockDiscount";

//assets
import { SvgFilledHeart } from "assets/icons/js/SvgFilledHeart";
import { SvgBlankHeart } from "assets/icons/js/SvgBlankHeart.js";
import { SvgShare } from "assets/icons/js/SvgShare";
import SvgBackArrow from "assets/icons/js/SvgBackArrow";
import { SvgSearch } from "assets/icons/js/SvgSearch";
import { ReactComponent as PdfLogo } from "assets/pdf.svg";

// customHooks
import { useUser } from "customHooks/useUser";
import { AddingToCollection } from "helpers/addToCollection";

// scss
import "./style.scss";
import { ListingInterface } from "context/ListingData";
import { useQuery } from "react-query";
import { goAxiosInstance } from "helpers/axiosInstance";
import { useTheme } from "components/ListingNew/ListingTheme";

const NavbarMobile = ({
	name,
	listingList,
	link,
	cal,
	image,
	price,
	openSharePopup,
}: any) => {
	const visitsData = useQuery(["visits"], () => {
		return goAxiosInstance({
			url: `visits?id=${data.data?.listing_list?.id}
				`,
			method: "GET",
		});
	});
	let navigate = useNavigate();
	// check if the user exists
	const user = useUser();

	const [save, setSave] = useState(listingList.inDreamList);

	// @ts-ignore
	const { data } = useContext(ListingInterface);
	// console.log(window.history.length)
	const oldPrice = data?.data?.listingList?.PER_NIGHT_CHARGE_REAL;

	const theme = useTheme();

	return (
		<div className="navbar-mobile__wrapper">
			<div className="navbar-top">
				<div className="navbar-mobile__name">
					<SvgBackArrow
						onClick={() => {
							if (window.history.length === 1) {
								navigate("/");
							} else if (window.history.length === 2) {
								// navigate(
								// 	`/search?location=${
								// 		listingList?.FILE_REFERENCE.split("-")[0]
								// 	}&checkin=&checkout=&guests=&rooms=&lat=${
								// 		listingList?.LATITUDE
								// 	}&lon=${listingList?.LONGITUDE}`,
								// );
								navigate("/");
							} else {
								navigate(-1);
							}
						}}
					/>
					{/* {theme?.name !== "xseries" && (
						<div
							className="text-sm-bold  navbar-search"
							onClick={() => {
								navigate("/mobile-search");
							}}
							style={
								theme?.name === "xseries"
									? {
											background: theme.background,
											color: theme.baseTextColor,
											border: theme.borderBtn.border,
									  }
									: {}
							}
						>
							<p>{name}</p>
							<SvgSearch
								color={
									theme?.name === "xseries" ? "rgb(189, 154, 100)" : "#dddd"
								}
							/>
						</div>
					)} */}
				</div>
				<div className="navbar-mobile__actions">
					<button
						onClick={() => {
							window.open(
								`https://api.whatsapp.com/send/?phone=918291050012&text=Send%20me%20a%20PDF%20for%20${
									listingList?.file_reference?.split("-")[0]
								}--${listingList?.id}`,
							);
						}}
					>
						<PdfLogo />
					</button>
					<button
						onClick={() => {
							openSharePopup();
						}}
					>
						<SvgShare />
					</button>
					<button
						aria-label="Save"
						type="button"
						onClick={() => {
							clevertap.event.push("shortlisted_villa", {
								villaName: listingList.file_reference,
								listingId: listingList.id,
								url: window.location.href,
								img: image,
								high_demand_message:
									visitsData?.data?.data?.data?.VALUE >= 50 &&
									`${visitsData?.data?.data?.data?.VALUE} Travelers saw this property in the last few hours`,
							});
							if (!user) {
								navigate("/");
							}
							if (user) {
								setSave((prev: any) => !prev);
								AddingToCollection(listingList.id, save);
							}
						}}
					>
						{!save ? <SvgBlankHeart /> : <SvgFilledHeart />}
					</button>
				</div>
			</div>
			{listingList.participating_rewards_program !== "N" ? (
				<UnlockDiscount
					price={price ? price : oldPrice}
					id={listingList.ID}
					theme={theme}
				/>
			) : null}
		</div>
	);
};

export default NavbarMobile;
